import React from 'react';
import { FileIcon, DeleteIcon, PDFIcon } from './Icons';
import { Progress, Tooltip } from 'antd';
import { 
    FileImageOutlined,
    FileExcelOutlined,
    FileGifOutlined,
    FileTextOutlined,
    FileWordOutlined,
    FileZipOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';
const extensionMap = {
    png: FileImageOutlined,
    jpg: FileImageOutlined,
    jpeg: FileImageOutlined,
    gif: FileGifOutlined,
    pdf: PDFIcon,
    txt: FileTextOutlined,
    xlsx: FileExcelOutlined,
    xls: FileExcelOutlined,
    csv: FileExcelOutlined,
    doc: FileWordOutlined,
    docx: FileWordOutlined,
    odt: FileWordOutlined,
    zip: FileZipOutlined,
    rar: FileZipOutlined,
    '7z': FileZipOutlined,
}
const FileUploadWidget = ({ file, deleteFile, upload = false }) => {
    const extension = (file.name || file.fileName).split('.').pop().toLowerCase();
    const IconComp = extensionMap[extension] ? extensionMap[extension] : FileIcon

    return (
        <div key={file.name || file.fileName} className={classNames("m-t-xs position-relative amc-preview-thumbnail", {'m-l-xs m-b-xs': !!upload})}>
            <div className="d-flex justify-content-center align-items-center image-icon">
                {file.thumbnail ? <img alt={file.name || file.fileName} style={{ width: '100%' }} src={file.thumbnail} /> : <IconComp style={{ fontSize: 20, color: 'grey' }} />}
            </div>

            <div className="attachment-name">
                <Tooltip title={file.name || file.fileName} placement="bottom">
                    <div className="text-ellipsis p-l-xs" style={{position: 'relative', top:'50%', transform: 'translateY(-50%)'}}>
                        {file.name || file.fileName}
                    </div>
                </Tooltip>
            </div>
            {
                upload && <div className="attachment-progress" style={{ display: file.percent === 100 ? 'none' : 'block' }}>
                    <Progress percent={file.percent} showInfo={false} size="small" strokeWidth={5} />
                </div>
            }
            {upload && <div className="m-t-xs m-r-xs" style={{ position: 'absolute', top: 0, right: 0 }}>
                {<Tooltip title="Remove file">
                    <DeleteIcon className="clickable danger" onClick={() => deleteFile(file.id)} />
                </Tooltip>
                }
            </div>}
        </div>
    )
}

export default FileUploadWidget;